import gql from 'graphql-tag';


export const UPDATE = gql(`
mutation($data: DataSourceLookUpInputType!){
    dataSourceLookUpMutation{
        updateDataSourceLookUp(data:$data){
            id,
            dataSourceId,
            idFieldLinked,
            idFieldDescription,
            tableAlias,
            maxRowsReturned
            queryDisplay,
            queryWhere,
            queryOrder,        
            addNewvaluesOnTheFly,
            additionaFieldsOnSearch
            fieldsOnReturn
            idControlType,
            componentId
        }
    }
}
`);



export const ADD = gql(`
mutation($data: DataSourceLookUpInputType!){
    dataSourceLookUpMutation{
        addDataSourceLookUp(data:$data){
            id,
            dataSourceId,
            idFieldLinked,
            idFieldDescription,
            tableAlias,
            maxRowsReturned
            queryDisplay,
            queryWhere,
            queryOrder,        
            addNewvaluesOnTheFly,
            additionaFieldsOnSearch
            fieldsOnReturn
            idControlType,
            componentId
        }
    }
}
`);

export const DELETE = gql(`
mutation($id: Int!){
    dataSourceLookUpMutation{
        deleteDataSourceLookUp(id:$id)
    }
}
`);

